import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ArgusSyncOptionEnum } from "../../../models/enums/argus-sync-option.enum";
import { ArgusIntegrationService } from "../../../services/ArgusIntegrationService";
import { DestroyBase } from "../ng-destroy-base";
import { EventBusService } from "../../../services/event-bus.service";

/**
 * Argus dialog component
 */
@Component({
  selector: 'argus-dialog',
  templateUrl: './argus-dialog.component.html',
  styleUrls: ['./argus-dialog.component.css']
})
export class ArgusDialogComponent extends DestroyBase implements OnInit, OnDestroy {
  /**
   * Config set to any
   */
  config: any;

  /**
   * Content set to any
   */
  content: any;

  /**
   * Show close set to any
   */
  showClose: any;

  /**
   * Translation key title set to any
   */
  translationKeyTitle: any = 'exportToArgusConfirmDialog.titlePush';

  /**
  * Available argus valuations
  */
  argusValuations = [];

  /**
  * Selected argus valuation
  */
  selectedArgusValuation: number;

  /**
   * Should continue button be disabled - based on the dropdown selection
   */
  shouldDisableContinue = false;

  /**
   * Argus portfolio id
   */
  argusValuationPortfolioId: string;

  /**
   * Argus sync option
   */
  @Input() syncOption: ArgusSyncOptionEnum;

  /**
   * Project Id
   */
  @Input() projectId: number;

  /**
   * Valuation portfolio id
   */
  @Input() valuationPortfolioId: number;

  /**
   * Constructor for translate service
   */
  constructor(private eventBus: EventBusService,
    private ref: ChangeDetectorRef,
    private _argusIntegrationService: ArgusIntegrationService) {
    super();
  }

  /**
   * Translation title service
   */
  ngOnInit(): void {
    this.selectedArgusValuation = null;
    if (this.projectId) {
      this.subscriptions.add(this._argusIntegrationService.getArgusValuations(this.projectId, this.valuationPortfolioId).subscribe(data => {
        this.argusValuations = data;
      }));
    }
    this.eventBus.subscribeEvent('argusDialog', (config) => {
      this.translationKeyTitle = 'exportToArgusConfirmDialog.titlePush';
      this.config = config;
      this.content = this.config.dialogContent();
      this.showClose = this.config.shouldShowCloseButton();

      if (config.translationKeyTitle) {
        this.translationKeyTitle = config.translationKeyTitle;
      }

      this.ref.markForCheck();
    });
  }

  /**
   * Retrieves argus sync option enum
   */
  get ArgusSyncOptionEnum() {
    return ArgusSyncOptionEnum;
  }

  /**
   * On close should cancel
   */
  onClose() {
    this.selectedArgusValuation = null;
    this.cancel();
  }

  /**
   * Confirm on success
   */
  confirm() {
    this.content = null;
    if (this.config?.success) {
      this.config.success(this.argusValuationPortfolioId);
    }
  }

  /**
   * Cancel on failure
   */
  cancel() {
    this.selectedArgusValuation = null;
    this.content = null;
    if (this.config?.cancel) {
      this.config.cancel();
    }
  }

  /**
   * Handles value changes
   * @param value
   */
  handleValueChange(value: any) {
    this.argusValuationPortfolioId = value;
  }
}
